import { TbChevronDown } from 'react-icons/tb';
import clsx from 'clsx';
import { memo, forwardRef } from 'react';

interface Props extends React.SelectHTMLAttributes<HTMLSelectElement> {
  className?: string;
  children?: React.ReactNode;
  showIcon?: boolean;
}

const SelectComponent = memo(
  forwardRef<HTMLSelectElement, Props>(function Select(
    { children, className, showIcon = true, ...props },
    ref,
  ) {
    return (
      <div className="relative w-full">
        <select
          ref={ref}
          className={clsx(
            'block h-full w-full cursor-pointer appearance-none rounded border border-gray-300 bg-white px-3 py-1.5 pr-8 text-xs text-slate-600 focus:border-blue-400 focus:outline-none',
            className,
          )}
          {...props}
        >
          {children}
        </select>
        {showIcon && (
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-400">
            <TbChevronDown size={12} />
          </div>
        )}
      </div>
    );
  }),
);

const SelectOption = ({
  children,
  className,
  ...props
}: React.SelectHTMLAttributes<HTMLOptionElement>) => {
  return (
    <option className={className} {...props}>
      {children}
    </option>
  );
};

interface SelectComponentType
  extends React.MemoExoticComponent<
    React.ForwardRefExoticComponent<Props & React.RefAttributes<HTMLSelectElement>>
  > {
  Option: typeof SelectOption;
}

export const Select = SelectComponent as SelectComponentType;
Select.Option = SelectOption;
